<template>
    <div class="page-reply-tabs">
        <WxAccountManage v-model="currentAccountInfo" />
        <v-page-header :title="_isEA ? $t('自动回复') : $t('公众号接入')" />
        <div
            v-if="currentAccount != null && currentAccount.type == 2"
            class="reply-status"
        >
            <v-status-bar
                kind="alarm"
                show-close-icon
            >
                <span>{{ $t('由于QQ公众平台调整 ，已绑定QQ公众号用户将无法继续使用企点QQ公众号相关功能。') }}</span>
            </v-status-bar>
        </div>
        <div
            v-if="accountID"
            class="reply-tabs"
        >
            <reply-tabs class="tabs-container" />
        </div>
    </div>
</template>

<script>
// 注意，因为这个组件营销和客服是公用的。所以在去框架机的时候，专为客服单独写了一个组件。
import ReplyTabs from './ReplyTabs-nohengine.vue';
import WxAccountManage from './wxAccountManage.vue';
import BasicMixin from '../../groupSend/mixins/basic';
// const { accountID } = window.data && window.data.data;
// eslint-disable-next-line no-underscore-dangle
// const _isEA = /^10004$/.test(window.data.set.current); // 这个变量并没有被使用，template中的同名变量也没有发现定义的地方。
export default {
    components: { ReplyTabs, WxAccountManage },
    mixins: [BasicMixin],
    props: {
        currentAccountInfo: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            selectedTab: 0,
        };
    },
    computed: {
        accountID() {
            return window.data && window.data.data && window.data.data.accountID;
        },
        currentAccount() {
            const current = window.data && window.data.data && window.data.data.accountList;
            if (Array.isArray(current)) {
                current.forEach((item) => {
                    if (item.accountID && item.accountID === this.accountID) {
                        return item;
                    }
                });
            }
            return null;
        },
    },
    watch: {
        currentAccountInfo(val) {
            this.$emit('input', val);
        },
    },
    created() {
    },
    mounted() {
    },
    methods: {
        select(value, option) {
            this.$emit('select', value, option);
        },
    },
};
</script>
<style lang="less" scoped>
@import '~src/common/common.less';
@import '~src/common/base.less';

.group-sender-header{
    display: flex;
    justify-content: space-between;

    .sub-page-title{
        line-height: 32px;
    }
}
.tabs-container{
    margin-bottom: var(--spacing-loose);
}

.tip-content{
    font-size: 14px;
    padding: 5px 20px;
    color: #1e2330;
    text-align: left;
    .wecom-rule{
        width: 316px;
    }
    .title-p{
        margin-top: 20px;
    }
    .text-gray {
        color: #66686c!important;
    }
}
</style>
<style lang="less">
.page-reply-tabs {
    .v-page-header {
        margin-bottom: 0;
    }
}
</style>

